module.exports = __webpack_public_path__ + "static/media/parking_list_sample_template - Sheet1.403c019a.csv";